import { render, staticRenderFns } from "./ass-scope.vue?vue&type=template&id=73c830e6"
import script from "./ass-scope.vue?vue&type=script&lang=js"
export * from "./ass-scope.vue?vue&type=script&lang=js"
import style0 from "./ass-scope.vue?vue&type=style&index=0&id=73c830e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports